export { ArrowLeftNarrow as default } from './ArrowLeftNarrow';
